// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 800px) {
  .is-hidden-desktop {
    display: none !important;
  }
}
.jb-aside-mobile-toggle {
  color: #999 !important;
}

.navbar-link:not(.is-arrowless)::after {
  border: 3px solid transparent;
  border-radius: 2px;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.625em;
  margin-top: -0.4375em;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: rotate(-45deg);
  transform-origin: center;
  width: 0.625em;
}

.navbar {
  padding-top: 0;
  padding-bottom: 0;
  background-color: #fff;
  left: 0;
  position: fixed;
  right: 0;
  z-index: 30;
  top: 0;
}

.navbar-brand {
  align-items: stretch;
  display: flex;
  flex-shrink: 0;
  min-height: 3.25rem;
}

.navbar-brand a.navbar-item:focus, .navbar-brand a.navbar-item:hover {
  background-color: transparent;
}

.navbar-menu {
  display: none;
}

.navbar-item,
.navbar-link {
  color: #fff;
  display: block;
  line-height: 1.5;
  padding: 0.5rem 0.75rem;
  position: relative;
}

.navbar-link {
  color: #333;
}

.navbar-item .icon:only-child,
.navbar-link .icon:only-child {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

a.navbar-item,
.navbar-link {
  cursor: pointer;
}

a.navbar-item:hover {
  color: #999;
}

a.navbar-item.is-active {
  background-color: #fafafa;
  color: #3273dc;
  cursor: default;
}
a.navbar-item.is-edit {
  background-color: #777;
  color: #fff;
}

.navbar-link.is-active, .navbar-link:focus, .navbar-link:focus-within, .navbar-link:hover {
  background-color: #eee;
  color: #333;
}

.navbar-item {
  display: block;
  flex-grow: 0;
  flex-shrink: 0;
}
.navbar-item img {
  max-height: 1.75rem;
}
.navbar-item.has-dropdown {
  padding: 0;
}

.navbar-content {
  flex-grow: 1;
  flex-shrink: 1;
}

.navbar-link:not(.is-arrowless) {
  padding-right: 2.5em;
}
.navbar-link:not(.is-arrowless)::after {
  border-color: #3273dc;
  margin-top: -0.375em;
  right: 1.125em;
}

.navbar-dropdown {
  font-size: 0.875rem;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}
.navbar-dropdown .navbar-item {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  color: #666;
  font-weight: bold;
}

.navbar-divider {
  background-color: #f5f5f5;
  border: none;
  display: none;
  height: 2px;
  margin: 0.5rem 0;
}

@media screen and (max-width: 799px) {
  .navbar-brand .navbar-item {
    align-items: center;
    display: flex;
  }
  .navbar-link::after {
    display: none;
  }
  .navbar-menu {
    background-color: #fff;
    box-shadow: 0 8px 16px rgba(10, 10, 10, 0.1);
    padding: 0.5rem 0;
  }
  .navbar-menu.is-active {
    display: block;
  }
  .navbar.is-fixed-top .navbar-menu {
    -webkit-overflow-scrolling: touch;
    max-height: calc(100vh - 3.25rem);
    overflow: auto;
  }
}
@media screen and (min-width: 800px) {
  .navbar,
  .navbar-menu,
  .navbar-start,
  .navbar-end {
    align-items: stretch;
    display: flex;
  }
  .navbar {
    min-height: 3.25rem;
  }
  .navbar.is-transparent a.navbar-item:focus, .navbar.is-transparent a.navbar-item:hover {
    background-color: transparent !important;
  }
  .navbar.is-transparent .navbar-link:focus, .navbar.is-transparent .navbar-link:hover {
    background-color: transparent !important;
  }
  .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus .navbar-link, .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:focus-within .navbar-link, .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:hover .navbar-link {
    background-color: transparent !important;
  }
  .navbar.is-transparent .navbar-dropdown a.navbar-item:focus, .navbar.is-transparent .navbar-dropdown a.navbar-item:hover {
    background-color: #f5f5f5;
    color: #0a0a0a;
  }
  .navbar-item,
  .navbar-link {
    align-items: center;
    display: flex;
  }
  .navbar-item {
    display: flex;
  }
  .navbar-item.has-dropdown {
    align-items: stretch;
  }
  .navbar-item.has-dropdown-up .navbar-link::after {
    transform: rotate(135deg) translate(0.25em, -0.25em);
  }
  .navbar-item.has-dropdown-up .navbar-dropdown {
    border-bottom: 2px solid #dbdbdb;
    border-radius: 6px 6px 0 0;
    border-top: none;
    bottom: 100%;
    box-shadow: 0 -8px 8px rgba(10, 10, 10, 0.1);
    top: auto;
  }
  .navbar-item.is-hoverable:focus .navbar-dropdown, .navbar-item.is-hoverable:focus-within .navbar-dropdown, .navbar-item.is-hoverable:hover .navbar-dropdown {
    display: block;
  }
  .navbar-menu {
    flex-grow: 1;
    flex-shrink: 0;
  }
  .navbar-start {
    justify-content: flex-start;
    margin-right: auto;
  }
  .navbar-end {
    justify-content: flex-end;
    margin-left: auto;
  }
  .navbar-dropdown {
    background-color: #fff;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
    display: none;
    font-size: 0.875rem;
    right: 0;
    min-width: 100%;
    position: absolute;
    top: 100%;
    z-index: 20;
  }
  .navbar-dropdown .navbar-item {
    padding: 0.375rem 1rem;
    white-space: nowrap;
  }
  .navbar-dropdown a.navbar-item {
    padding-right: 3rem;
  }
  .navbar-divider {
    display: block;
  }
}
nav.navbar {
  background-color: #fff;
  box-shadow: 0 1px 0 rgba(24, 28, 33, 0.04);
}
nav.navbar .navbar-item.has-user-avatar .is-user-avatar {
  margin-right: 0.75rem;
  display: inline-flex;
  width: 1.75rem;
  height: 1.75rem;
}
nav.navbar .navbar-item.has-user-avatar .is-user-avatar .is-user-avatar img {
  margin: 0 auto;
  border-radius: 290486px;
}
nav.navbar .navbar-item.has-divider {
  border-right: 1px solid rgba(219, 219, 219, 0.25);
}
nav.navbar .navbar-item.no-left-space {
  padding-left: 0;
}
nav.navbar .navbar-item.has-dropdown {
  padding-right: 0;
  padding-left: 0;
}
nav.navbar .navbar-item.has-dropdown .navbar-link {
  padding-right: 1.125rem;
  padding-left: 1.125rem;
}

@media screen and (max-width: 799px) {
  nav.navbar {
    display: flex;
    padding-right: 0;
  }
  nav.navbar .navbar-brand {
    flex: 1;
  }
  nav.navbar .navbar-brand.is-right {
    flex: none;
  }
  nav.navbar .navbar-menu {
    position: absolute;
    width: 100vw;
    padding-top: 0;
    top: 3.25rem;
    left: 0;
  }
  nav.navbar .navbar-menu .navbar-item .icon:first-child {
    margin-right: 0.75rem;
  }
  nav.navbar .navbar-menu .navbar-item.has-dropdown > .navbar-link {
    background-color: #f5f5f5;
  }
  nav.navbar .navbar-menu .navbar-item.has-dropdown > .navbar-link .icon:last-child {
    display: none;
  }
  nav.navbar .navbar-menu .navbar-item.has-user-avatar > .navbar-link {
    display: flex;
    align-items: center;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
}
@media screen and (min-width: 800px) {
  nav.navbar .navbar-item {
    padding-right: 1.125rem;
    padding-left: 1.125rem;
  }
  nav.navbar .navbar-item:not(.is-desktop-icon-only) .icon:first-child {
    margin-right: 0.75rem;
  }
  nav.navbar .navbar-item.is-desktop-icon-only span:not(.icon) {
    display: none;
  }
}
@media screen and (min-width: 800px) {
  nav.navbar {
    padding-left: 14rem;
  }
  nav.navbar,
  body {
    transition: padding-left 250ms ease-in-out 50ms;
  }
  aside.aside {
    display: block;
    width: 14rem;
  }
  aside.aside .menu-list .icon {
    width: 3rem;
  }
  aside.aside .menu-list span.menu-item-label {
    display: inline-block;
  }
}
aside.aside {
  overflow-y: scroll;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 40;
  height: 100vh;
  padding: 0;
  box-shadow: none;
  background: #2e323a;
}
aside.aside .aside-tools {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
  background-color: #17191e;
  color: #fff;
  line-height: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  flex: 1;
}
aside.aside .aside-tools .icon {
  margin-right: 0.75rem;
}
aside.aside .aside-tools-sync > a {
  color: #fff;
}
aside.aside .aside-tools-sync > a:hover {
  color: #999;
}
aside.aside .menu-list li a.has-dropdown-icon {
  position: relative;
  padding-right: 3rem;
}
aside.aside .menu-list li a.has-dropdown-icon .dropdown-icon {
  position: absolute;
  top: 0.5rem;
  right: 0;
}
aside.aside .menu-list li ul {
  display: none;
  border-left: 0;
  background-color: #282c33;
  padding-left: 0;
  margin: 0 0 0.75rem;
}
aside.aside .menu-list li ul li a {
  padding: 0.75rem 0 0.75rem 0.75rem;
  font-size: 0.95rem;
}
aside.aside .menu-list li ul li a.has-icon {
  padding-left: 0;
}
aside.aside .menu-list li ul li a.is-active:not(:hover) {
  background: transparent;
}
aside.aside .menu-label {
  padding: 0 0.75rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

@media screen and (max-width: 799px) {
  body {
    overflow-x: hidden;
  }
  nav.navbar {
    transition: margin-left 250ms ease-in-out 50ms;
    width: 100vw;
  }
  nav.navbar.has-aside {
    margin-left: 15rem;
  }
  aside.aside {
    transition: left 250ms ease-in-out 50ms;
    width: 15rem;
    display: block;
    left: -15rem;
  }
  aside.aside.has-aside {
    left: 0;
  }
  aside.aside .image img {
    max-width: 4.95rem;
  }
  aside.aside .menu-list a .icon {
    width: 3rem;
  }
  aside.aside .menu-list a span.menu-item-label {
    display: inline-block;
  }
}
nav.navbar .icon i {
  height: inherit;
}

@media screen and (max-width: 799px) {
  .navbar-item:not(.has-dropdown),
  .navbar-link {
    display: flex;
  }
}
aside.aside .menu-list li a.has-icon {
  display: flex;
}
aside.aside .menu-list li a.has-icon .icon i {
  height: auto;
}
aside.aside .menu-list li a.has-icon .menu-item-label {
  line-height: 1.5rem;
  height: 1.5rem;
}

.dropdown {
  display: inline-flex;
  position: relative;
  vertical-align: top;
}
.dropdown.is-hoverable:hover .dropdown-menu {
  display: block;
}

.dropdown-menu {
  display: none;
  left: 0;
  min-width: 12rem;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  z-index: 20;
}

.dropdown-content {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}

.dropdown-item {
  color: #4a4a4a;
  display: block;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0.375rem 1rem;
  position: relative;
}

a.dropdown-item,
button.dropdown-item {
  padding-right: 3rem;
  text-align: left;
  white-space: nowrap;
  width: 100%;
}

a.dropdown-item:hover,
button.dropdown-item:hover {
  background-color: #f5f5f5;
  color: #0a0a0a;
}

.dropdown-divider {
  background-color: #dbdbdb;
  border: none;
  display: block;
  height: 1px;
  margin: 0.5rem 0;
}

.menu {
  font-size: 1rem;
}

.menu-list {
  line-height: 1.25;
}
.menu-list a {
  border-radius: 0;
  color: #bbb;
  display: flex;
  padding: 0.5rem 0;
}
.menu-list li ul {
  border-left: 1px solid #dbdbdb;
  margin: 0.75em;
  padding-left: 0.75em;
}

.menu-label {
  color: #666f81;
  font-size: 0.75em;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.menu-label:not(:first-child) {
  margin-top: 1em;
}
.menu-label:not(:last-child) {
  margin-bottom: 1em;
}

aside.aside .menu-list li ul.nestedNavContainer {
  display: block;
  margin-bottom: 0;
  padding-left: 0;
}
aside.aside .menu-list li ul.nestedNavContainer li a.nestedNavLink {
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-left: 0.75em;
}
aside.aside .menu-list li ul.nestedNavContainer a.navbar-item.is-active {
  background-color: #fafafa;
}`, "",{"version":3,"sources":["webpack://./packages/aiand-scenario/frontend/src/assets/css/navbar.scss"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAA;EACF;AACF;AAEA;EACE,sBAAA;AAAF;;AAGA;EACE,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,wBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,WAAA;EACA,MAAA;AAAF;;AAGA;EACE,oBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAAF;;AAIE;EAEE,6BAAA;AAFJ;;AAMA;EACE,aAAA;AAHF;;AAMA;;EAEE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAHF;;AAKA;EACE,WAAA;AAFF;;AAKA;;EAEE,qBAAA;EACA,sBAAA;AAFF;;AAKA;;EAEE,eAAA;AAFF;;AAME;EAEE,WAAA;AAJJ;;AASE;EACE,yBAAA;EACA,cAAA;EACA,eAAA;AANJ;AAQE;EACE,sBAAA;EACA,WAAA;AANJ;;AAWE;EAIE,sBAAA;EACA,WAAA;AAXJ;;AAeA;EACE,cAAA;EACA,YAAA;EACA,cAAA;AAZF;AAcE;EACE,mBAAA;AAZJ;AAeE;EACE,UAAA;AAbJ;;AAiBA;EACE,YAAA;EACA,cAAA;AAdF;;AAiBA;EACE,oBAAA;AAdF;AAgBE;EACE,qBAAA;EACA,oBAAA;EACA,cAAA;AAdJ;;AAkBA;EACE,mBAAA;EACA,sBAAA;EACA,mBAAA;AAfF;AAiBE;EACE,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;AAfJ;;AAmBA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE;IACE,mBAAA;IACA,aAAA;EAhBF;EAmBA;IACE,aAAA;EAjBF;EAoBA;IACE,sBAAA;IACA,4CAAA;IACA,iBAAA;EAlBF;EAmBE;IACE,cAAA;EAjBJ;EAsBE;IACE,iCAAA;IACA,iCAAA;IACA,cAAA;EApBJ;AACF;AAwBA;EACE;;;;IAIE,oBAAA;IACA,aAAA;EAtBF;EAyBA;IACE,mBAAA;EAvBF;EA2BM;IAEE,wCAAA;EA1BR;EA+BM;IAEE,wCAAA;EA9BR;EAoCQ;IAGE,wCAAA;EApCV;EA0CM;IAEE,yBAAA;IACA,cAAA;EAzCR;EA+CA;;IAEE,mBAAA;IACA,aAAA;EA7CF;EAgDA;IACE,aAAA;EA9CF;EAgDE;IACE,oBAAA;EA9CJ;EAkDI;IACE,oDAAA;EAhDN;EAmDI;IACE,gCAAA;IACA,0BAAA;IACA,gBAAA;IACA,YAAA;IACA,4CAAA;IACA,SAAA;EAjDN;EAqDI;IAGE,cAAA;EArDN;EAyDA;IACE,YAAA;IACA,cAAA;EAvDF;EA0DA;IACE,2BAAA;IACA,kBAAA;EAxDF;EA2DA;IACE,yBAAA;IACA,iBAAA;EAzDF;EA4DA;IACE,sBAAA;IACA,8BAAA;IACA,+BAAA;IAEA,2CAAA;IACA,aAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;EA3DF;EA6DE;IACE,sBAAA;IACA,mBAAA;EA3DJ;EA8DE;IACE,mBAAA;EA5DJ;EAqEA;IACE,cAAA;EAnEF;AACF;AAsEA;EACE,sBAAA;EACA,0CAAA;AApEF;AAuEI;EACE,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;AArEN;AAuEQ;EACE,cAAA;EACA,uBAAA;AArEV;AA0EI;EACE,iDAAA;AAxEN;AA2EI;EACE,eAAA;AAzEN;AA4EI;EACE,gBAAA;EACA,eAAA;AA1EN;AA4EM;EACE,uBAAA;EACA,sBAAA;AA1ER;;AAgFA;EACE;IACE,aAAA;IACA,gBAAA;EA7EF;EA+EE;IACE,OAAA;EA7EJ;EA8EI;IACE,UAAA;EA5EN;EA+EE;IACE,kBAAA;IACA,YAAA;IACA,cAAA;IACA,YAAA;IACA,OAAA;EA7EJ;EAgFM;IACE,qBAAA;EA9ER;EAiFM;IACE,yBAAA;EA/ER;EAiFQ;IACE,aAAA;EA/EV;EAmFM;IACE,aAAA;IACA,mBAAA;IACA,oBAAA;IACA,uBAAA;EAjFR;AACF;AAuFA;EACE;IACE,uBAAA;IACA,sBAAA;EArFF;EAuFE;IACE,qBAAA;EArFJ;EAwFE;IACE,aAAA;EAtFJ;AACF;AA0FA;EACE;IACE,mBAAA;EAxFF;EA2FA;;IAEE,+CAAA;EAzFF;EA4FA;IACE,cAAA;IACA,YAAA;EA1FF;EA6FI;IACE,WAAA;EA3FN;EA8FI;IACE,qBAAA;EA5FN;AACF;AAiGA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;AA/FF;AAiGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,OAAA;AA/FJ;AAiGI;EACE,qBAAA;AA/FN;AAmGM;EACE,WAAA;AAjGR;AAkGQ;EACE,WAAA;AAhGV;AAuGI;EACE,kBAAA;EACA,mBAAA;AArGN;AAuGM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AArGR;AAyGI;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAvGN;AAyGM;EACE,kCAAA;EACA,kBAAA;AAvGR;AAyGQ;EACE,eAAA;AAvGV;AA0GQ;EACE,uBAAA;AAxGV;AA8GE;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;AA5GJ;;AAgHA;EACE;IACE,kBAAA;EA7GF;EA+GA;IACE,8CAAA;IACA,YAAA;EA7GF;EA8GE;IACE,kBAAA;EA5GJ;EA+GA;IACE,uCAAA;IACA,YAAA;IACA,cAAA;IACA,YAAA;EA7GF;EA+GE;IACE,OAAA;EA7GJ;EAgHE;IACE,kBAAA;EA9GJ;EAmHM;IACE,WAAA;EAjHR;EAmHM;IACE,qBAAA;EAjHR;AACF;AAuHA;EACE,eAAA;AArHF;;AAwHA;EACE;;IAEE,aAAA;EArHF;AACF;AAwHA;EACE,aAAA;AAtHF;AAwHE;EACE,YAAA;AAtHJ;AAyHE;EACE,mBAAA;EACA,cAAA;AAvHJ;;AA2HA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;AAxHF;AA0HE;EACE,cAAA;AAxHJ;;AA4HA;EACE,aAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAzHF;;AA4HA;EACE,sBAAA;EACA,kBAAA;EACA,4EAAA;EACA,sBAAA;EACA,mBAAA;AAzHF;;AA4HA;EACE,cAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAzHF;;AA4HA;;EAEE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAzHF;;AA4HA;;EAEE,yBAAA;EACA,cAAA;AAzHF;;AA4HA;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AAzHF;;AA4HA;EACE,eAAA;AAzHF;;AA4HA;EACE,iBAAA;AAzHF;AA2HE;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AAzHJ;AAiIE;EACE,8BAAA;EACA,cAAA;EACA,oBAAA;AA/HJ;;AAmIA;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AAhIF;AAkIE;EACE,eAAA;AAhIJ;AAmIE;EACE,kBAAA;AAjIJ;;AAqIA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAlIF;AAmIE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;AAjIJ;AAmIE;EACE,yBAAA;AAjIJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
